export enum CheckBoxState {
    AllSelected = 1,
    PartialSelected,
    UnSelected
}